import {
  BaseGetAllFilter,
  BaseReadApi,
  baseReadApiFactory,
  HttpClient,
} from '@amzn/dots-core-ui';
import { Configuration } from '../models';

export type ConfigurationId = Configuration['id'];

export interface ConfigurationGetAllFilter
  extends BaseGetAllFilter<ConfigurationId> {
  name?: string;
  _name?: string;
  config?: string;
  packageCreatedBy?: string;
  packageId?: number;
  packageType?: string;
  isFavorite?: boolean;
  ids?: number[];
  page?: number;
  pageSize?: number;
}

export interface ConfigurationApi
  extends BaseReadApi<
    ConfigurationId,
    Configuration,
    ConfigurationGetAllFilter
  > {
  create: (
    packageId: number,
    configuration: Partial<Configuration>
  ) => Promise<Configuration>;
  update: (
    id: number,
    configuration: Partial<Configuration>
  ) => Promise<Configuration>;
  remove: (id: number) => Promise<void>;
}

export const configurations = (client: HttpClient): ConfigurationApi => ({
  ...baseReadApiFactory(client, 'configuration'),
  create: (
    packageId: number,
    configuration: Partial<Configuration>
  ): Promise<Configuration> =>
    client.post({
      url: '/configuration',
      payload: { ...configuration, packageId },
    }),
  update: (
    id: number,
    configuration: Partial<Configuration>
  ): Promise<Configuration> =>
    client.put({
      url: `/configuration/${id}`,
      payload: {
        ...configuration,
        id,
      },
    }),
  remove: (id: number): Promise<void> =>
    client.delete({ url: `/configuration/${id}` }),
});
